import {getCountryLabel} from 'components/common/listConstants';

const formatLocation = model => {
    const {house, houseNumber, street, state, city, country, postalCode, location} = model;
    if (house || street || state || city || country || postalCode || houseNumber) {
        let result = '';
        result += getCountryLabel(country) || country;
        if (city) result += `, ${city}`;
        if (street) result += `, ${street}`;
        if (house || houseNumber) result += `, ${house || houseNumber}`;
        return result;
    }
    if (!location || !location.address) return location || '';
    let result = '';
    result += location.address.country;
    if (location.address.city) result += `, ${location.address.city}`;
    if (location.address.street) result += `, ${location.address.street}`;
    if (location.address.houseNumber) result += `, ${location.address.houseNumber}`;
    return result;
};

export default formatLocation;
